import { Pipe, PipeTransform } from "@angular/core";
import { TriggerCategoryList } from "../data/trigger-list-id";

@Pipe({
  name: 'triggerIdConvertToCategory',
  standalone: true
})
export class TriggerIdConvertToCategoryPipe implements PipeTransform {
  transform(categoryId: number): string {
    if (categoryId) {
      const categoryName = TriggerCategoryList.find((category) => category.categoryId === categoryId);
      return categoryName?.categoryName || String(categoryId);
    }
    return String(categoryId);
  }
}
